<template>
  <div>
    <Select v-model="v1" filterable placeholder="展品类别" :disabled="open?true:false" @on-change="selectChangeGetSub" @on-clear :label-in-value="true">
      <Option v-for="item in type" :value="item.name" :tag="item.id" :key="item.id">{{ item.name }}</Option>
    </Select>
    <Select v-if="type2" v-model="v2" filterable placeholder="一级类别" :disabled="open?true:false" @on-change="selectChangeGetSub2" :label-in-value="true">
      <Option v-for="item2 in type2" :value="item2.name" :tag="item2.id" :key="item2.id">{{ item2.name }}</Option>
    </Select>
    <Select v-if="type3" v-model="v3" filterable placeholder="二级类别" :disabled="open?true:false" @on-change="selectChangeGetSub3" :label-in-value="true">
      <Option v-for="item3 in type3" :value="item3.name" :tag="item3.id" :key="item3.id">{{ item3.name }}</Option>
    </Select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "category-filed",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    Modal: {
      type: Array,
      default: function () {
        return [];
      }
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      exhibition: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  data () {
    return {
      AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",
      exTypeArr: [], // 展商类别
      v1: null,
      v2: null,
      v3: null,
      value: null,
      value2: null,
      value3: null,
      type: null,
      type2: null,
      type3: null
    };
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductByGroupId: "categoryModule/getProductByGroupId",
      getProductByParentId: "categoryModule/getProductByParentId",
    }),
    async init () {
      let categoryData = await this.getProductByGroupId({
        groupId: this.exhibitionInfo.groupId,
        level: 0,
        loadChild: true,
      });
      if (categoryData && categoryData.length) {
        this.type = categoryData;
      } else {
        this.type = [];
      }
      const copyData = JSON.parse(JSON.stringify(this.Modal));
      if (this.Modal) {
        if (this.Modal[0]) {
          this.v1 = this.Modal[0].name;
          this.type.forEach(c => {
            if (c.id === this.Modal[0].Id) {
              this.selectChange(c.name);
              let list = this.Modal[0].List[0];
              c.list.forEach(v => {
                this.type2 = c.list;
                if (v.id === list.Id) {
                  this.v2 = this.Modal[0].name;
                  this.selectChange2(v.name);
                  let list2 = this.Modal[0].List[0].List[0];
                  v.list.forEach(z => {
                    if (z.id === list2.Id) {
                      this.v3 = list2.name;
                      this.selectChange3(z.name);
                    }
                  });
                }
              });
            }
          });
        }
      }
      this.$emit("sendModal", copyData);
    },
    send () {
      let value = [];
      let value2 = [];
      let value3 = [];
      let modal = [];
      if (this.value) {
        value = JSON.parse(JSON.stringify(this.value));
        value.list = [];
        modal = value;
      }
      if (this.value2) {
        value2 = JSON.parse(JSON.stringify(this.value2));
        value2.list = [];
        modal.list = [value2];
      }
      if (this.value3) {
        value3 = JSON.parse(JSON.stringify(this.value3));
        value3.list = [];
        modal.list[0] = [value3];
      }
      const copyData = JSON.parse(JSON.stringify(modal));

      this.$emit("sendModal", [copyData]);
    },
    selectChange (e) {
      if (!e) {
        this.v1 = '';
        this.v2 = '';
        this.v3 = '';
      } else {
        this.v1 = e;
      }
      this.value2 = null;
      this.value3 = null;
      if (this.type && this.type.length) {
        this.type.forEach(c => {
          if (c.name === e) {
            this.value = c;
          }
          if (c.name === e && c.list && c.list.length) {
            this.type2 = c.list;
          }
        });
      }
      this.send();
    },
    selectChange2 (e) {
      this.v2 = e;
      this.value3 = null;
      if (this.type2 && this.type2.length) {
        this.type2.forEach(c => {
          if (c.name === e) {
            this.value2 = c;
          }
          if (c.name === e && c.list && c.list.length) {
            this.type3 = c.list;
          }
        });
      }
      this.send();
    },
    selectChange3 (e) {
      this.v3 = e;
      if (this.type3 && this.type3.length) {
        this.type3.forEach(c => {
          if (c.name === e) {
            this.value3 = c;
          }
        });
      }
      this.send();
    },

    async selectChangeGetSub (e) {
      console.log('selectChangeGetSub:', e);
      if (!e) {
        this.v1 = '';
        this.v2 = '';
        this.v3 = '';
      } else {
        this.v1 = e.value;
      }
      this.value2 = null;
      this.value3 = null;
      if (this.type && this.type.length) {
        this.type.forEach(c => {
          if (c.name === e.value) {
            this.value = c;
          }
        });
      }
      let subArr = await this.getProductByParentId(e.tag);
      console.log('selectChangeGetSub: subArr2', subArr);
      this.type2 = subArr || null;
      this.send();
    },
    async selectChangeGetSub2 (e) {
      this.v2 = e.value;
      this.value3 = null;
      if (this.type2 && this.type2.length) {
        this.type2.forEach(c => {
          if (c.name === e.value) {
            this.value2 = c;
          }
        });
      }
      let subArr = await this.getProductByParentId(e.tag);
      console.log('selectChangeGetSub: subArr3', subArr);
      if (!subArr) return;
      this.type3 = subArr || null;
      this.send();
    },
    async selectChangeGetSub3 (e) {
      this.v3 = e.value;
      if (this.type3 && this.type3.length) {
        this.type3.forEach(c => {
          if (c.name === e.value) {
            this.value3 = c;
          }
        });
      }
      this.send();
    },
  }
};
</script> 
